// * -------------------------------- NPM --------------------------------------
// export { default as queryString } from 'query-string' // https://www.npmjs.com/package/query-string
const qs = require('qs'); //tslint:disable-line

export const stringify = (object: { [key: string]: any }) => qs.stringify(object, { arrayFormat: 'indices' })
